import { createSlice } from '@reduxjs/toolkit';

export const integrationBarSlice = createSlice({
  name: 'integrationBar',
  initialState: {
    uploadInProgress: false,
  },
  reducers: {
    integrationUploadStarted: (state) => {
      state.uploadInProgress = true;
    },
    integrationUploadFinished: (state) => {
      state.uploadInProgress = false;
    },
  },
});

export const { integrationUploadStarted, integrationUploadFinished } =
  integrationBarSlice.actions;
